export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_13.4683dcc5.jpg";